import type { ExtractSubjectType, MongoQuery, SubjectRawRule } from '@casl/ability';
import { createMongoAbility } from '@casl/ability';
import type { PackRule } from '@casl/ability/extra';
import { unpackRules } from '@casl/ability/extra';
import { useQuery } from '@tanstack/react-query';

import type { CaslRulesDto, ParkAndRideFacility, User } from '@/modules/api/backend';
import { Action, Subject } from '@/modules/api/backend';
import { backendApiCaslGetRulesOptions } from '@/modules/api/backend/@tanstack/react-query.gen';

export type SubjectEntity = User | ParkAndRideFacility;

export type AppAbilityTuple = [Action, Subject | SubjectEntity];

export function createAbility(rules: CaslRulesDto['rules']) {
  return createMongoAbility<AppAbilityTuple>(
    unpackRules(rules as PackRule<SubjectRawRule<Action, ExtractSubjectType<Subject | SubjectEntity>, MongoQuery>>[]),
    {
      anyAction: Action.MANAGE,
      anySubjectType: Subject.All,
    },
  );
}

export function useAbility() {
  const { data } = useQuery(backendApiCaslGetRulesOptions());
  const ability = data && createAbility(data.rules);

  return { ability };
}
